import React from "react";
import { Box } from "@mui/system";
import { AppBar, Button, Menu, MenuItem, Toolbar } from "@mui/material";
import Logo from "../images/catvante-logo.png"
import PreservingLink from "../PreservingLink";
import { Person } from "@mui/icons-material";
import { logout } from "../LoginGuard/loginGuard";

export default function Header(props: {logoutEnabled: boolean}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky">
      <Toolbar sx={{justifyContent: "space-between"}}>
        <Box m={2} sx={{display: "flex"}} component={PreservingLink} to="/" flexWrap="wrap">
          <Box
            component="img"
            src={Logo}
            sx={{
              maxHeight: {
                xs:40,
                sm: 55,
                md: 70
              }
            }}
          /> {/*remove bg color*/}
        </Box>
        {
          props.logoutEnabled &&
          <React.Fragment>
            <Box
              component={Button}
              m={2}
              sx={{
                display: "flex",
                bgcolor: "grey",
                ":hover":{
                  bgcolor: "darkgray"
                },
                height: {
                  xs:40,
                  sm: 55,
                  md: 70
                },
                width: {
                  xs:40,
                  sm: 55,
                  md: 70
                },
                borderRadius: {
                  xs:40/2,
                  sm: 55/2,
                  md: 70/2
                }
              }}
              flexWrap="wrap"
              onClick={(event) => handleClick(event)}
            >
              <Person
                sx={{
                  color: "white",
                  height: {
                    xs:25,
                    sm: 40,
                    md: 55
                  },
                  width: {
                    xs:25,
                    sm: 40,
                    md: 55
                  },
                  }}
              />
            </Box>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={() => logout()}>Logout</MenuItem>
            </Menu>
          </React.Fragment>
        }
      </Toolbar>
    </AppBar>
  );
}